import { Outlet, useLocation } from 'react-router-dom';
import { useViewMode } from '../../contexts/ViewModeContext';
import { useAuth } from '../../contexts/AuthContext';
import Sidebar from './Sidebar';
import { MobileBottomNav, MobileHeader } from './MobileLayout';
import ViewToggleBanner from './ViewToggleBanner';
import { Toaster } from '../ui/sonner';

const pageTitles = {
  '/dashboard': 'Dashboard',
  '/admin/queue': 'Patient Queue',
  '/admin/users': 'Users',
  '/admin/patients': 'Patients',
  '/admin/medicines': 'Medicines',
  '/admin/medicine-updates': 'Medicine Updates',
  '/admin/knowledge-base': 'Knowledge Base',
  '/admin/media-library': 'Media Library',
  '/admin/analytics': 'Analytics',
  '/admin/settings': 'Settings',
  '/doctor/patients': 'Patients',
  '/doctor/consultations': 'Consultations',
  '/doctor/prescriptions': 'Prescriptions',
  '/doctor/follow-ups': 'Follow-Ups',
  '/doctor/medicines': 'Medicine Search',
  '/counsellor/patients': 'Patients',
  '/counsellor/appointments': 'Appointments',
};

export default function DashboardLayout() {
  const { isMobile } = useViewMode();
  const { user } = useAuth();
  const location = useLocation();

  const pageTitle = pageTitles[location.pathname] || 'Eden Clinic';

  if (isMobile) {
    return (
      <div className="min-h-screen bg-[#F2F4F7]" data-testid="dashboard-layout-mobile">
        <ViewToggleBanner />
        <MobileHeader title={pageTitle} />
        <main className="pb-[100px]">
          <div className="px-4 py-4">
            <Outlet />
          </div>
        </main>
        <MobileBottomNav role={user?.role} />
        <Toaster position="top-center" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background" data-testid="dashboard-layout">
      <ViewToggleBanner />
      <Sidebar />
      <main className="ml-64 min-h-screen">
        <div className="p-8">
          <Outlet />
        </div>
      </main>
      <Toaster position="top-right" />
    </div>
  );
}
